/* eslint-disable sonarjs/no-duplicate-string */
import Tokens from 'styles/tokens';

export const planFeatureList = {
  'basic-monthly': [
    'Recording & Transcription',
    'Limited AI-generated Notes',
    'Collaborative Note-taking',
    'Agenda Preparation',
    'Unlimited 1:1 Scheduler'
  ],
  'lite-monthly': [
    'Automatic Video Recording',
    'Unlimited Transcription',
    'Advanced AI-generated Notes',
    'Group & Round-Robin Scheduler',
    'CRM & Dialer Integration'
  ],
  'lite-yearly': [
    'Automatic Video Recording',
    'Unlimited Transcription',
    'Advanced AI-generated Notes',
    'Group & Round-Robin Scheduler',
    'CRM & Dialer Integration'
  ],

  'plus-monthly': [
    <span key='plus-monthly'>
      Everything in{' '}
      <strong style={{ color: Tokens.colors.gunmetal }}>
        AI Meeting Assistant
      </strong>
    </span>,
    'Manual and AI Scorecards',
    'Talk Pattern & Topic Intelligence',
    'Smart Tracker Intelligence',
    'Engagement & ROI Intelligence'
  ],
  'plus-yearly': [
    <span key='plus-yearly'>
      Everything in{' '}
      <strong style={{ color: Tokens.colors.gunmetal }}>
        AI Meeting Assistant
      </strong>
    </span>,
    'Manual and AI Scorecards',
    'Talk Pattern & Topic Intelligence',
    'Smart Tracker Intelligence',
    'Engagement & ROI Intelligence'
  ],

  'premium-monthly': [
    <span key='premium-monthly'>
      Everything in{' '}
      <strong style={{ color: Tokens.colors.gunmetal }}>
        Conversation Intelligence
      </strong>
    </span>,
    'Automatic CRM field updates',
    'Custom Deal Boards, Risk Scores',
    'Roll-up Forecasting & Reports',
    'AI Win-Loss Analysis (Add-on)'
  ],
  'premium-yearly': [
    <span key='premium-monthly'>
      Everything in{' '}
      <strong style={{ color: Tokens.colors.gunmetal }}>
        Conversation Intelligence
      </strong>
    </span>,
    'Automatic CRM field updates',
    'Custom Deal Boards, Risk Scores',
    'Roll-up Forecasting & Reports',
    'AI Win-Loss Analysis (Add-on)'
  ],
  'startup-monthly': [
    'Unlimited Free View-only Seats',
    'Unlimited 1:1 Scheduling',
    'Automatic Video Recording',
    'Unlimited Real-time Transcription',
    'Unlimited AI Summary Notes',
    'Ask Avoma for a Meeting',
    'AI Email Follow-ups',
    'Auto Save Notes to CRM Records',
    'Dialer Integration'
  ],
  'startup-half-yearly': [
    'Unlimited Free View-only Seats',
    'Unlimited 1:1 Scheduling',
    'Automatic Video Recording',
    'Unlimited Real-time Transcription',
    'Unlimited AI Summary Notes',
    'Ask Avoma for a Meeting',
    'AI Email Follow-ups',
    'Auto Save Notes to CRM Records',
    'Dialer Integration'
  ],
  'startup-yearly': [
    'Unlimited Free View-only Seats',
    'Unlimited 1:1 Scheduling',
    'Automatic Video Recording',
    'Unlimited Real-time Transcription',
    'Unlimited AI Summary Notes',
    'Ask Avoma for a Meeting',
    'AI Email Follow-ups',
    'Auto Save Notes to CRM Records',
    'Dialer Integration'
  ],
  'organization-monthly': [
    'Custom AI Topics & Templates',
    'Group and Round-robin Scheduling',
    'Limited Conversation Intelligence',
    'Smart Playlist & AI Automations',
    'Translation & Notes Regeneration',
    'Ask Avoma across All Meetings',
    'Custom AI Email Templates',
    'Enforce Org-level Policies',
    'API Integration & Webhooks'
  ],
  'organization-half-yearly': [
    'Custom AI Topics & Templates',
    'Group and Round-robin Scheduling',
    'Limited Conversation Intelligence',
    'Smart Playlist & AI Automations',
    'Translation & Notes Regeneration',
    'Ask Avoma across All Meetings',
    'Custom AI Email Templates',
    'Enforce Org-level Policies',
    'API Integration & Webhooks'
  ],
  'organization-yearly': [
    'Custom AI Topics & Templates',
    'Group and Round-robin Scheduling',
    'Limited Conversation Intelligence',
    'Smart Playlist & AI Automations',
    'Translation & Notes Regeneration',
    'Ask Avoma across All Meetings',
    'Custom AI Email Templates',
    'Enforce Org-level Policies',
    'API Integration & Webhooks'
  ],
  'enterprise-v2-monthly': [
    'Designated Success Manager',
    'Concierge Onboarding & Training',
    'Quarterly Business Reviews',
    'Unlimited Usage Intelligence',
    'Team-Specific Access Controls',
    'Mutually Signed DPAs',
    'Single Sign-On (SAML/OIDC)',
    'Data Retention Policies',
    'HIPAA Compliance'
  ],
  'enterprise-v2-half-yearly': [
    'Designated Success Manager',
    'Concierge Onboarding & Training',
    'Quarterly Business Reviews',
    'Unlimited Usage Intelligence',
    'Team-Specific Access Controls',
    'Mutually Signed DPAs',
    'Single Sign-On (SAML/OIDC)',
    'Data Retention Policies',
    'HIPAA Compliance'
  ],
  'enterprise-v2-yearly': [
    'Designated Success Manager',
    'Concierge Onboarding & Training',
    'Quarterly Business Reviews',
    'Unlimited Usage Intelligence',
    'Team-Specific Access Controls',
    'Mutually Signed DPAs',
    'Single Sign-On (SAML/OIDC)',
    'Data Retention Policies',
    'HIPAA Compliance'
  ]
};

export const PLAN_SEAT_LIMIT_FALLBACKS = {
  startup: {
    type: 'max',
    value: 25
  },
  organization: {
    type: 'max',
    value: 100
  },
  'enterprise-v2': {
    type: 'min',
    value: 10
  }
};

export const ADDON_FEATURE_LIST = {
  'lead-router-addon': [
    '1:1 Scheduling Links',
    'Customize Event Titles',
    'Embed Scheduler to your Website',
    'Save contacts to CRM',
    'Group Scheduling',
    'Round Robin Scheduling',
    'Real-time Lead Qualification and Routing',
    'Round Robin Scheduling based on Custom Rules and CRM fields',
    'Lead Routing based CRM Contact and Account Owner',
    'Lead Routing based on CRM Custom fields',
    'Form Field Based Router',
    'SDR to AE Handoff Router'
  ],
  'ci-addon': [
    'AI Coaching Recommendations',
    'Auto Call Scoring with AI',
    'Custom AI Scorecards',
    'SPICED, Sandler, MEDDICC, etc. AI Scorecards',
    'Smart Playlists – Rule Based Auto Curation',
    'Real-time Answer Assistant',
    'Member Performance Trend Dashboard',
    'Scorecard Performance Trend Dashboard',
    'Interaction & Talk-Pattern Skills',
    'Standard Topic Intelligence',
    'Custom Keyword Trackers',
    'Custom Smart Topic Trackers'
  ],
  'ri-addon': [
    '"Ask Avoma" across Accounts',
    '"Ask Avoma" across Deals',
    'Dealboard for Pipeline Review',
    '2-way CRM Field Updates',
    'AI-powered Deal Risk Alerts',
    'AI Deal Health Score',
    'AI Sales Methodology Tracker',
    'Roll-up & Aggregated Forecasting',
    'AI Win-Loss Deal Analysis',
    'Pipeline and Forecasting Reports',
    'Native CRM Integration',
    'Dialer Integration'
  ],
  'task-management-addon': [
    'Auto-create Tasks from Meetings',
    'AI-powered Task Prioritization',
    'AI-powered Task Assignment',
    'Auto-draft Follow-up Emails'
  ],
  'sso-addon': [
    'SAML 2.0 Single Sign-On',
    'OpenID Connect (OIDC) Support',
    'Mobile App SSO Support'
  ]
};

export const PLAN_SUBTITLES = {
  'enterprise-v2': (
    <strong>
      Everything in <span className='text-yellow-600'>Organization</span>, plus:
    </strong>
  ),
  startup: (
    <strong>
      <span className='text-avoma-red'>Unlimited</span> AI Meeting Assistant:
    </strong>
  ),
  organization: (
    <strong>
      Everything in <span className='text-green-600'>Startup</span>, plus:
    </strong>
  )
};

export const PLAN_NAMES = {
  basic: 'Basic',
  lite: 'AI Meeting Assistant',
  plus: 'Conversation Intelligence',
  trial: 'Unrestricted Trial',
  premium: 'Revenue Intelligence',
  enterprise: 'Enterprise',
  'enterprise-v2': 'Enterprise',
  startup: 'Startup',
  team: 'Startup',
  organization: 'Organization'
};

export const BILLING_ADDONS = {
  aiWinLossAnalysis: 'AI Win-Loss Analysis',
  'lead-router-addon': 'Lead Router',
  'ci-addon': 'Conversation Intelligence',
  'ri-addon': 'Revenue Intelligence',
  'task-management-addon': 'Task Management'
};
